// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { useGSAP } from '@gsap/react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollToTop } from './components/ScrollToTop';
// import IndustryDetail from './pages/IndustryDetail';

// import Home from './pages/Home';

// import Footer from './components/Footer';
// import About from './components/About';
// import Contact from './pages/Contact';
// import Services from './components/Services';
// import Navigation from './components/Navigation';
// import OurPurpose from './components/Sections/OurPurpose';
// import IndustryPage from './pages/IndustryPage';
// import ProcessPage from './pages/ProcessPage';
// import ServiceDetailPage from './pages/ServiceDetailPage';
// import ProcessStepDetail from './pages/ProcessStepDetail';
// import PolicyAndPrivacy from './pages/PolicyAndPrivacy';






// gsap.registerPlugin(ScrollTrigger);


// function App() {
//   useGSAP(() => {
//     gsap.config({
//       autoSleep: 60,
//       force3D: false,
//       nullTargetWarn: false
//     });
//   });

//   React.useEffect(() => {
//     const style = document.createElement('style');
//     style.textContent = `
//       @keyframes blob {
//         0% { transform: translate(0px, 0px) scale(1); }
//         33% { transform: translate(30px, -50px) scale(1.1); }
//         66% { transform: translate(-20px, 20px) scale(0.9); }
//         100% { transform: translate(0px, 0px) scale(1); }
//       }
//       .animate-blob {
//         animation: blob 7s infinite;
//       }
//       .animation-delay-2000 {
//         animation-delay: 2s;
//       }
//       .animation-delay-4000 {
//         animation-delay: 4s;
//       }
//       .animation-delay-1000 {
//         animation-delay: 1s;
//       }
//       .animation-delay-3000 {
//         animation-delay: 3s;
//       }
//     `;
//     document.head.appendChild(style);
//     return () => document.head.removeChild(style);
//   }, []);

//   return (
//     <Router>
//       <ScrollToTop />
//       <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-purple-50 relative">
//         <Navigation />
//         <div className="flex-grow">
//           <Routes>
//             <Route path="/" element={<Home />} />
            
//             <Route path='/industries' element={<IndustryPage/>} />
           
//             <Route path="/services" element={<Services />} />
//             <Route path="/about" element={<About />} />
//             <Route path="/contact" element={<Contact />} />
//             <Route path="/industry/:industryName" element={<IndustryDetail />} />
//             <Route path="/key-differentiators" element={<OurPurpose />} />
//             <Route path="/process" element={<ProcessPage />} />
//             <Route path="/service/:serviceId" element={<ServiceDetailPage />} />
//             <Route path="/industries/:slug" element={<IndustryDetail />} />
//             <Route path="/process/:stepKey" element={<ProcessStepDetail />} />
//             <Route path='/privacy' element={<PolicyAndPrivacy/>}/>

//           </Routes>
//         </div>
//         <Footer />
//       </div>
//     </Router>
//   );
// }

// export default App;


import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToTop } from './components/ScrollToTop';
import IndustryDetail from './pages/IndustryDetail';

import Home from './pages/Home';

import Footer from './components/Footer';
import About from './components/About';
import Contact from './pages/Contact';
import Services from './components/Services';
import Navigation from './components/Navigation';
import OurPurpose from './components/Sections/OurPurpose';
import IndustryPage from './pages/IndustryPage';
import ProcessPage from './pages/ProcessPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import ProcessStepDetail from './pages/ProcessStepDetail';
import PolicyAndPrivacy from './pages/PolicyAndPrivacy';

// Products
import ProductsPage from './pages/ProductsPage';
import RetailPage from './pages/RetailPage';
import ManufacturingPage from './pages/ManufacturingPage';
import TransportPage from './pages/TransportPage';

gsap.registerPlugin(ScrollTrigger);

function App() {
  useGSAP(() => {
    gsap.config({
      autoSleep: 60,
      force3D: false,
      nullTargetWarn: false
    });
  });

  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes blob {
        0% { transform: translate(0px, 0px) scale(1); }
        33% { transform: translate(30px, -50px) scale(1.1); }
        66% { transform: translate(-20px, 20px) scale(0.9); }
        100% { transform: translate(0px, 0px) scale(1); }
      }
      .animate-blob {
        animation: blob 7s infinite;
      }
      .animation-delay-2000 {
        animation-delay: 2s;
      }
      .animation-delay-4000 {
        animation-delay: 4s;
      }
      .animation-delay-1000 {
        animation-delay: 1s;
      }
      .animation-delay-3000 {
        animation-delay: 3s;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-purple-50 relative">
        <Navigation />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />

            <Route path='/industries' element={<IndustryPage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/industry/:industryName" element={<IndustryDetail />} />
            <Route path="/key-differentiators" element={<OurPurpose />} />
            <Route path="/process" element={<ProcessPage />} />
            <Route path="/service/:serviceId" element={<ServiceDetailPage />} />
            <Route path="/industries/:slug" element={<IndustryDetail />} />
            <Route path="/process/:stepKey" element={<ProcessStepDetail />} />
            <Route path='/privacy' element={<PolicyAndPrivacy />} />

            {/* Products Routes */}
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/retail" element={<RetailPage />} />
            <Route path="/products/manufacturing" element={<ManufacturingPage />} />
            <Route path="/products/transport" element={<TransportPage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;